export const SWR_CONFIG = {
    refetchInterval: {
        slow: 1000 * 60 * 5,
        moderate: 1000 * 60 * 1,
        fast: 1000 * 10,
    },
};
